module.exports = __webpack_public_path__ + "static/media/schoolpic01.b30bee10.png";